import _slicedToArray from "/home/ubuntu/signup/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
export default function format(_ref) {
  var alternativeName = _ref.alternativeName,
    mainCities = _ref.mainCities,
    rawOffsetInMinutes = _ref.rawOffsetInMinutes,
    currentTimeOffsetInMinutes = _ref.currentTimeOffsetInMinutes;
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref2$useCurrentOffse = _ref2.useCurrentOffset,
    useCurrentOffset = _ref2$useCurrentOffse === void 0 ? false : _ref2$useCurrentOffse;
  var offsetInHours = useCurrentOffset ? getOffsetString(currentTimeOffsetInMinutes) : getOffsetString(rawOffsetInMinutes);
  return "".concat(offsetInHours.padStart(6, "+"), " ").concat(alternativeName, " - ").concat(mainCities.join(", "));
}
function getOffsetString(offsetInMinutes) {
  var absOffsetInMinutes = Math.abs(offsetInMinutes);
  var _map = [Math.floor(absOffsetInMinutes / 60), absOffsetInMinutes % 60].map(function (v) {
      return v.toString().padStart(2, "0");
    }),
    _map2 = _slicedToArray(_map, 2),
    hours = _map2[0],
    minutes = _map2[1];
  var durationInHoursMinutes = "".concat(hours, ":").concat(minutes);
  return "".concat(offsetInMinutes >= 0 ? "+" : "-").concat(durationInHoursMinutes);
}